import {useEffect, useState} from "react";
import {useTranslation, withTranslation} from "react-i18next";
import "./informes.scss";
import {Button, List} from "antd";
import localOrSessionStore from "../../../_helpers/localOrSessionStore";
import variables from "../../../_constants/variables";
import {ShareAltOutlined} from "@ant-design/icons";
import {xcService} from "../../../_services/xcService";
import CardStudent from "./cardStudent";
import {useLocation} from "react-router-dom";
import InformeCervoPDF from "./cervo.pdf.page";
import * as _ from "lodash";
import endpoint from "shared/endpoints";

function InformeCervo(props) {
    const {search} = useLocation();
    const {t} = useTranslation();
    const [answers, setAnswers] = useState();
    const storage = localOrSessionStore({key: variables.REMEMBER});
    const user = JSON.parse(storage.getItem(variables.USER));
    const userType = storage.getItem(variables.USER_TYPE);
    const studentUid = new URLSearchParams(search).get('user');
    const [studentProfile, setStudentProfile] = useState(null);
    const [studentArea, setStudentArea] = useState();
    const year = +new URLSearchParams(search).get('year');
    const [studentHistory, setStudentHistory] = useState();

    useEffect(() => {

        const answersPath = userType === 'STUDENT' ? endpoint.studentAnswer.getAll('CERVO', {query: {year}}) : `/v1/student/${studentUid}/answers/CERVO?year=${year}`;
        xcService.getToken(answersPath).then(({data}) => setAnswers(data.data));

        const areaCevoPath = userType === 'STUDENT' ? `/v1/student/area/CERVO?year=${year}` : `/v1/student/${studentUid}/area/CERVO?year=${year}`
        xcService.getToken(areaCevoPath).then(({data}) => {

            setStudentArea(data.data)
        });

    }, []);


    const getHistory = () => {
        if (studentUid){

            xcService.getToken(`/v1/${userType === 'STUDENT' ? `student/profile/history/` : `master/${studentUid}/history/`}${year}`)
                .then(({data}) => {
                    setStudentHistory(data.data)
                    let mStudentProfile = studentProfile;
                    if (mStudentProfile && data.data.course) {
                        mStudentProfile.course.id = data.data.course.id;
                        mStudentProfile.course.name = data.data.course.name;
                        setStudentProfile(mStudentProfile);
                    }
                })

        }
    }


    useEffect(() => {
        if (studentUid && (userType !== 'STUDENT')) xcService.getToken(`/v1/student/${studentUid}/profile`)
            .then(({data}) => {
                setStudentProfile(data.data)
                getHistory(studentUid)
            })
        else {
            //setStudentProfile(localOrSessionStore({key: variables.USER}))

            xcService.getToken('/v1/me').then(({data}) => {
                setStudentProfile(data.data)
                getHistory(studentUid)
            });

        }
        if (studentUid){

            xcService.getToken(`/v1/${userType === 'STUDENT' ? `student/profile/history/` : `master/${studentUid}/history/`}${year}`)
                .then(({data}) => setStudentHistory(data.data))

        }
    }, [studentUid]);


    return (user &&
        <div className={"container dasboard-informes"}>
            <div className={"gridInformes"}>
                <div className={"colLeftInformes"}>
                    <h3>{t("informes.title")}</h3>
                    <h4>{t("informes.cervosubtitle")}</h4>

                    {studentProfile && <CardStudent t={t} studentProfile={studentProfile}  studentHistory={studentHistory} />}
                    {/* <h6>{t("informes.cervopreferente")}</h6> */}
                    <h6>{t("informes.ceibapreferente")}</h6>
                    <div className={"cardArea"}>
                        <div className={"img"}>
                            {studentArea &&
                                <img src={`/assets/img/ri${studentArea.area.image}`}/>
                            }
                        </div>

                        <div className={"title"}>{studentArea && studentArea.area.like}</div>
                    </div>
                    <p className={"is-desktop changefont"}>{t("informes.comenta")}</p>
                </div>
                <div className={"colRightInformes"}>
                    <div className={"colRightInformesTop"}>
                        <div className={"listaAreas"}>
                            <h3>{t("informes.cervopreferente")}</h3>

                            <List
                                grid={{column: 1}}
                                header={null}
                                footer={null}
                                dataSource={_.filter(answers, function (o) {
                                    return o.assessment && !o.assessment.area.isGoal
                                })}
                                renderItem={item => (
                                    <List.Item>
                                        <div className={"headerItem headerItemInforme"}>
                                            <>
                                                {item.points !== 99 ?

                                                    <div style={{
                                                        borderBottomRightRadius: 18,
                                                        borderTopRightRadius: 18,
                                                        minWidth: 192,
                                                        width: `${(item.points === 999 ? 0 : 10 * item.points)}%`
                                                    }}
                                                         className={`txtPoints ${item.points >= 0 && item.points < 5 ? "redBar" :
                                                             item.points >= 5 && item.points < 8 ? "yellowBar" : item.points === 999 ? "" : "greenBar"
                                                         } informeBarra`}>
                                                        <span>{item.assessment.area.like}</span>
                                                    </div>
                                                    :
                                                    <div className={"txtPoints informeBarra"}>
                                                        <span>{item.assessment.area.like}</span>
                                                    </div>
                                                }
                                            </>

                                            {item.points !== 99 &&
                                                <span
                                                    className={"pointsInforme"}>{+item.points === 999 ? t('indeciso') : item.points}</span>
                                            }
                                        </div>
                                    </List.Item>
                                )}
                            />
                        </div>


                        <div className={"listaRespuestas"}>
                            <p className={"title"}
                               dangerouslySetInnerHTML={{__html: t("informes.cervotusrespuestas")}}/>


                            <List
                                grid={{column: 1}}
                                header={null}
                                footer={null}
                                dataSource={_.filter(answers, function (o) {
                                    return o.assessment &&  o.assessment.area.isGoal
                                })}
                                renderItem={item => (
                                    <List.Item>
                                        <div className={"headerItem headerItemInforme"}>
                                            <>
                                                {item.points !== 99 ?

                                                    <div style={{
                                                        borderBottomRightRadius: 18,
                                                        borderTopRightRadius: 18,
                                                        minWidth: 192,
                                                        width: `${(item.points === 999 ? 0 : 10 * item.points)}%`
                                                    }}
                                                         className={`txtPoints ${item.points >= 0 && item.points < 5 ? "redBar" :
                                                             item.points >= 5 && item.points < 8 ? "yellowBar" : item.points === 999 ? "" : "greenBar"
                                                         } informeBarra`}>
                                                        <span>{item.assessment.area.then}</span>
                                                    </div>
                                                    :
                                                    <div className={"txtPoints informeBarra"}>
                                                        <span>{item.assessment.area.then}</span>
                                                    </div>
                                                }
                                            </>

                                            {item.points !== 99 &&
                                                <span
                                                    className={"pointsInforme"}>{item.points === 999 ? t('indeciso') : item.points}</span>
                                            }
                                        </div>
                                    </List.Item>
                                )}
                            />
                        </div>

                    </div>
                    <p className={"is-mobile"}>{t("informes.comenta")}</p>
                    <div className={"colRightInformesBottom"}>
                        {studentProfile && answers && studentArea &&
                            <InformeCervoPDF    forDownload={false} props={props} studentProfile={studentProfile} studentHistory={studentHistory}
                                             answers={answers}
                                             studentArea={studentArea}/>}
                         {1 === 2 &&
                         <Button
                            icon={<ShareAltOutlined/>}
                            className="primaryButton">
                            {t("share")}
                        </Button>}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default withTranslation()(InformeCervo);


